const gameAliases = {
  Bandido: ['Bandido92', 'BandidoDice'],
  CherryBlast: ['CherryBlast90', 'CherryBlast92', 'CherryBlastDice', 'CherryBlastStreamer', 'CherryXmass'],
  DragonTiger: ['DragonTiger247'],
  DueloMahjong: ['DueloMahjong90', 'DueloMahjong92', 'DueloMahjongDice'],
  EmberInferno: ['EmberInferno92', 'EmberInfernoDice'],
  EmpireOfTheTiger: ['EmpireOfTheTiger92', 'EmpireOfTheTigerDice'],
  FishingJackpots: ['FishingJackpotsDice'],
  FishyCatch: ['FishyCatch92', 'FishyCatchDice'],
  FishyGuy: ['FishyGuy90', 'FishyGuy92', 'FishyGuyDice', 'FishyGuyStreamer'],
  GoldOfEgypt: ['GoldOfEgypt90', 'GoldOfEgypt92', 'GoldOfEgypt98', 'GoldOfEgyptDice', 'GoldOfEgyptStreamer'],
  JokersFortune: ['JokersFortune92', 'JokersFortuneDice'],
  JokersShow: ['JokersShow90', 'JokersShow92', 'JokersShowDice'],
  KraljBalkana: ['BalkanKing', 'BalkanKingDice'],
  NedAndTed: ['NedTed', 'NedTed247', 'NedTed92', 'NedTedDice'],
  PremierSlot: ['777WildStar', '777WildStar90', '777WildStar92', '777WildStarDice', 'PremierJackpot'],
  RandysRevenge: ['RandysRevenge92', 'RandysRevengeDice'],
  RedZoneRumble: ['RedZoneRumble90', 'RedZoneRumbleDice'],
  SugarBlast: ['SugarBlast90', 'SugarBlast92', 'SugarBlastStreamer', 'SugarDice'],
  SuperCup: ['BetanoGame', 'WorldFootballx2026'],
  Supernova: ['Supernova90', 'Supernova92', 'SupernovaDice', 'SupernovaStreamer'],
  TaleOfGems: ['TaleOfGems92', 'TaleOfGemsDice'],
  TolucaFortune: ['TolucaFortune90', 'TolucaFortune92', 'TolucaFortuneDice', 'TolucaFortuneStreamer'],
  WildAce: ['WildAce92', 'WildAceDice'],
};

export function resolveGameName(gameName) {
  const aliasEntry = Object.entries(gameAliases).find((aliases) => aliases[1].includes(gameName));
  return aliasEntry ? aliasEntry[0] : gameName;
}

export function resolveDisplayName(backendDisplayName) {
  const suffixes = ['90', '92', '98'];

  for (let i = 0; i < suffixes.length; i++) {
    if (backendDisplayName.endsWith(suffixes[i])) {
      return backendDisplayName.slice(0, -suffixes[i].length).trim();
    }
  }

  return backendDisplayName;
}
